/* Header: disclosure navigation, sticky state and Theme Editor-safe lifecycle. */
(function () {
  'use strict';
  if (customElements.get('bb-header')) return;

  class BBHeader extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = new AbortController();
      this.hoverTimers = new Set();
      const signal = this.lifecycle.signal;

      this.items = Array.from(this.querySelectorAll('.bb-nav__item--has-panel'));

      this.items.forEach((item) => {
        const toggle = item.querySelector('.bb-nav__toggle');
        const link = item.querySelector('.bb-nav__link');
        if (!toggle || !link) return;

        toggle.addEventListener('click', () => {
          this.cancelHoverTimers();
          this.toggle(item, !item.classList.contains('is-open'));
        }, { signal });

        let hoverTimer = null;
        const schedule = (open, delay) => {
          if (hoverTimer) {
            window.clearTimeout(hoverTimer);
            this.hoverTimers.delete(hoverTimer);
          }
          hoverTimer = window.setTimeout(() => {
            this.hoverTimers.delete(hoverTimer);
            hoverTimer = null;
            this.toggle(item, open);
          }, delay);
          this.hoverTimers.add(hoverTimer);
        };

        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') schedule(true, 320);
        }, { signal });

        item.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') schedule(false, 360);
        }, { signal });

        link.addEventListener('focus', () => {
          this.cancelHoverTimers();
          this.closeAll(item);
        }, { signal });
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            this.cancelHoverTimers();
            this.toggle(item, false);
          }
        }, { signal });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.cancelHoverTimers();
          this.closeAll();
        }
      }, { signal });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        this.cancelHoverTimers();
        const open = this.items.find((item) => item.classList.contains('is-open'));
        if (!open) return;
        this.toggle(open, false);
        const toggle = open.querySelector('.bb-nav__toggle');
        if (toggle) toggle.focus();
      }, { signal });

      this.desktopQuery = window.matchMedia('(min-width: 1200px)');
      this.desktopQuery.addEventListener('change', () => {
        this.cancelHoverTimers();
        this.closeAll();
        const drawer = this.querySelector('#bb-menu-drawer');
        if (this.desktopQuery.matches && drawer && drawer.open) {
          drawer.close();
          window.requestAnimationFrame(() => {
            const navLink = this.querySelector('.bb-nav__link');
            if (navLink) navLink.focus();
          });
        }
      }, { signal });

      if (this.classList.contains('bb-header--sticky')) {
        window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.onScroll();
      }

      const logo = this.querySelector('.bb-logo__img');
      if (logo && logo.getAttribute('width')) {
        this.style.setProperty('--bb-logo-w', logo.getAttribute('width') + 'px');
      }
    }

    disconnectedCallback() {
      if (this.lifecycle) this.lifecycle.abort();
      this.lifecycle = null;
      if (this.hoverTimers) {
        this.hoverTimers.forEach((timer) => window.clearTimeout(timer));
        this.hoverTimers.clear();
      }
    }

    cancelHoverTimers() {
      if (!this.hoverTimers) return;
      this.hoverTimers.forEach((timer) => window.clearTimeout(timer));
      this.hoverTimers.clear();
    }

    toggle(item, open) {
      if (!item) return;
      if (open) {
        this.cancelHoverTimers();
        this.closeAll(item);
      }
      item.classList.toggle('is-open', open);
      const toggle = item.querySelector('.bb-nav__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    }

    closeAll(except) {
      (this.items || []).forEach((item) => {
        if (item !== except) this.toggle(item, false);
      });
    }

    onScroll() {
      this.classList.toggle('is-scrolled', window.scrollY > 8);
    }
  }

  customElements.define('bb-header', BBHeader);
})();
